module.exports = fox._r("fonts/montserrat-hairline-webfont.svg", __webpack_public_path__ + "fonts/montserrat-hairline-webfont.svg");


//////////////////
// WEBPACK FOOTER
// ./fonts/montserrat-hairline-webfont.svg
// module id = 5
// module chunks = 5